import {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function DataKelasUpdate(
  props
) {
  const token = localStorage.getItem("token");
  const ascending = 0;

  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const [loadingSekolah, setLoadingSekolah] =
    useState(false);

  const [
    loadingTingkatan,
    setLoadingTingkatan,
  ] = useState(false);

  const [getCabang, setGetCabang] =
    useState([]);

  const [getSekolah, setGetSekolah] =
    useState([]);

  const [getTingkatan, setGetTingkatan] =
    useState([]);

  const [form, setForm] = useState({
    name_kelas: "",
    ysb_grade_level_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const safeValue = (value) => value ?? "";

  // =========================================
  // MENGISI DATA UPDATE
  // =========================================
  useEffect(() => {
    if (!props?.show) {
      return;
    }

    setForm({
      name_kelas: safeValue(
        props?.dataUpdate?.name_kelas
      ),

      ysb_grade_level_id: safeValue(
        props?.dataUpdate
          ?.ysb_grade_level_id
      ),

      ysb_branch_id: safeValue(
        props?.dataUpdate?.ysb_branch_id
      ),

      ysb_school_id: safeValue(
        props?.dataUpdate?.ysb_school_id
      ),
    });
  }, [props?.show, props?.dataUpdate]);

  // =========================================
  // GET CABANG
  // =========================================
  const GetResponseCabang =
    useCallback(async () => {
      try {
        const response = await APIMS.get(
          `/api/branches?page=1&limit=1000&ascending=${ascending}&search=`,
          fetchParams
        );

        setGetCabang(
          Array.isArray(response?.data?.data)
            ? response.data.data
            : []
        );
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data cabang",
        });

        setGetCabang([]);
      }
    }, [fetchParams]);

  useEffect(() => {
    GetResponseCabang();
  }, [GetResponseCabang]);

  // =========================================
  // GET SEKOLAH
  // =========================================
  const GetResponseSekolah =
    useCallback(async () => {
      if (!form.ysb_branch_id) {
        setGetSekolah([]);
        return;
      }

      setLoadingSekolah(true);

      try {
        const response = await APIMS.get(
          `/api/schools?page=1&limit=1000&ascending=${ascending}&search=&branch=${form.ysb_branch_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetSekolah(
            Array.isArray(
              response?.data?.data
            )
              ? response.data.data
              : []
          );
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data sekolah",
        });

        setGetSekolah([]);
      } finally {
        setLoadingSekolah(false);
      }
    }, [fetchParams, form.ysb_branch_id]);

  useEffect(() => {
    GetResponseSekolah();
  }, [GetResponseSekolah]);

  // =========================================
  // GET TINGKATAN
  // =========================================
  const GetResponseTingkatan =
    useCallback(async () => {
      if (
        !form.ysb_school_id ||
        !form.ysb_branch_id
      ) {
        setGetTingkatan([]);
        return;
      }

      setLoadingTingkatan(true);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=1&limit=1000&ascending=${ascending}&search=&branch=${form.ysb_branch_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          const grades = Array.isArray(response?.data?.data)
            ? response.data.data
            : [];
          setGetTingkatan(
            grades.filter(
              (grade) =>
                String(grade?.ysb_school_id ?? "") ===
                String(form.ysb_school_id)
            )
          );
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal memuat data tingkatan",
        });

        setGetTingkatan([]);
      } finally {
        setLoadingTingkatan(false);
      }
    }, [
      fetchParams,
      form.ysb_branch_id,
      form.ysb_school_id,
    ]);

  useEffect(() => {
    GetResponseTingkatan();
  }, [GetResponseTingkatan]);

  // =========================================
  // HANDLE CHANGE
  // =========================================
  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => {
      if (name === "ysb_branch_id") {
        return {
          ...previous,
          ysb_branch_id: value,
          ysb_school_id: "",
          ysb_grade_level_id: "",
        };
      }

      if (name === "ysb_school_id") {
        return {
          ...previous,
          ysb_school_id: value,
          ysb_grade_level_id: "",
        };
      }

      return {
        ...previous,
        [name]: value,
      };
    });
  };

  // =========================================
  // SUBMIT UPDATE
  // =========================================
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !form.ysb_branch_id ||
      !form.ysb_school_id ||
      !form.ysb_grade_level_id ||
      !form.name_kelas.trim()
    ) {
      ToastError.fire({
        icon: "error",
        title: "Semua data wajib diisi",
      });

      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APIMS.put(
        `/api/kelas/${props.id}`,
        {
          name_kelas:
            form.name_kelas.trim(),

          ysb_grade_level_id:
            form.ysb_grade_level_id,

          ysb_branch_id:
            form.ysb_branch_id,

          ysb_school_id:
            form.ysb_school_id,

          user_id: idUser,
        },
        fetchParams
      );

      if (
        response?.status === 200 ||
        response?.status === 201
      ) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Data kelas berhasil diperbarui",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memperbarui data kelas",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-kelas"
    >
      <div className="sims-modal-header">
        <div>
          <h5
            id="modal-update-kelas"
            className="sims-modal-title"
          >
            Update Kelas
          </h5>

        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          disabled={isSubmitting}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="sims-modal-body">
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="update-kelas-cabang"
              >
                Cabang <span>*</span>
              </label>

              <select
                id="update-kelas-cabang"
                name="ysb_branch_id"
                value={form.ysb_branch_id}
                onChange={handleChange}
                className="sims-form-select"
                disabled={isSubmitting}
                required
              >
                <option value="">
                  Pilih Cabang
                </option>

                {getCabang.map(
                  (cabang, index) => (
                    <option
                      key={
                        cabang?.branch_code ||
                        index
                      }
                      value={
                        cabang?.branch_code ||
                        ""
                      }
                    >
                      {cabang?.branch_name ||
                        "-"}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="update-kelas-sekolah"
              >
                Sekolah <span>*</span>
              </label>

              <select
                id="update-kelas-sekolah"
                name="ysb_school_id"
                value={form.ysb_school_id}
                onChange={handleChange}
                className="sims-form-select"
                disabled={
                  !form.ysb_branch_id ||
                  loadingSekolah ||
                  isSubmitting
                }
                required
              >
                <option value="">
                  {!form.ysb_branch_id
                    ? "Pilih Cabang terlebih dahulu"
                    : loadingSekolah
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                </option>

                {getSekolah
                  .filter(
                    (school) =>
                      school?.school_code !==
                      "BASEMENT_BEKASI"
                  )
                  .map((school, index) => (
                    <option
                      key={
                        school?.school_code ||
                        index
                      }
                      value={
                        school?.school_code ||
                        ""
                      }
                    >
                      {school?.school_name ||
                        "-"}
                    </option>
                  ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="update-kelas-tingkatan"
              >
                Tingkatan <span>*</span>
              </label>

              <select
                id="update-kelas-tingkatan"
                name="ysb_grade_level_id"
                value={
                  form.ysb_grade_level_id
                }
                onChange={handleChange}
                className="sims-form-select"
                disabled={
                  !form.ysb_school_id ||
                  loadingTingkatan ||
                  isSubmitting
                }
                required
              >
                <option value="">
                  {!form.ysb_school_id
                    ? "Pilih Sekolah terlebih dahulu"
                    : loadingTingkatan
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                </option>

                {getTingkatan.filter(
                  (grade) => String(grade?.ysb_school_id ?? "") === String(form.ysb_school_id)
                ).map(
                  (grade, index) => (
                    <option
                      key={grade?.id || index}
                      value={grade?.id || ""}
                    >
                      {grade?.name_level ||
                        "-"}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="update-kelas-nama"
              >
                Nama Kelas <span>*</span>
              </label>

              <input
                id="update-kelas-nama"
                type="text"
                name="name_kelas"
                value={form.name_kelas}
                onChange={handleChange}
                className="sims-form-input"
                autoComplete="off"
                disabled={isSubmitting}
                required
              />
            </div>
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Perbarui
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}
